module.exports = __webpack_public_path__ + "img/185.c54c3614.jpg";